import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import Serie from '@/views/serie/Serie.vue'
import ExibirDividaDisponivel from '@/views/ajuizamento/ExibirDividaDisponivel.vue'
import ExibirErrosAjuizamento from '@/views/ajuizamento/ExibirErrosAjuizamento.vue'
import ExibirAjuizadas from '@/views/ajuizamento/ExibirAjuizadas.vue'
import ExibirErrosProtesto from '@/views/protesto/ExibirErrosProtesto.vue'
import ExibirExcluidasAjuizamento from '@/views/ajuizamento/ExibirExcluidasAjuizamento.vue'
import ExibirExcluidasProtesto from '@/views/protesto/ExibirExcluidasProtesto.vue'
import ExibirExcecoesAjuizamento from '@/views/ajuizamento/ExibirExcecoesAjuizamento.vue'
import ExibirExcecoesProtesto from '@/views/protesto/ExibirExcecoesProtesto.vue'
import ExibirCDAEnviadasCRA from '@/views/protesto/ExibirCDAEnviadasCRA.vue'
import ExibirProcessosMontados from '@/views/ajuizamento/ExibirProcessosMontados.vue'
import CDADisponivelProtesto from '@/views/protesto/CDADisponivelProtesto.vue'
import CDASelecionadasProtesto from '@/views/protesto/CDASelecionadasProtesto.vue'
import Dashboard from '@/views/dashboard/Dashboard.vue'
import ConsultarCartasParaAssinatura from '@/views/carta/ConsultarCartasParaAssinatura.vue'
import EmitirCartasPesquisar from '@/views/carta/EmitirCartasPesquisar.vue'
import EmitirCartasIncluir from '@/views/carta/EmitirCartasIncluir.vue'
import ManterTabelionato from '@/views/cruds/tabelionato/ManterTabelionato.vue'
import ManterComarca from '@/views/cruds/comarca/ManterComarca.vue'
import ManterComarcaEditar from '@/views/cruds/comarca/ManterComarcaEditar.vue'
import ManterComarcaExibir from '@/views/cruds/comarca/ManterComarcaExibir.vue'
import ManterReuFederal from '@/views/cruds/reuFederal/ManterReuFederal.vue'
import ManterUsuario from '@/views/cruds/usuario/ManterUsuario.vue'
import ManterProcurador from '@/views/cruds/procurador/ManterProcurador.vue'
import ManterProcuradorEditar from '@/views/cruds/procurador/ManterProcuradorEditar.vue'
import ManterProcuradorExibir from '@/views/cruds/procurador/ManterProcuradorExibir.vue'
import ManterJuizo from '@/views/cruds/juizo/ManterJuizo.vue'
import ManterPeticao from '@/views/cruds/peticao/ManterPeticao.vue'
import ManterPeticaoEditar from '@/views/cruds/peticao/ManterPeticaoEditar.vue'
import ManterPeticaoExibir from '@/views/cruds/peticao/ManterPeticaoExibir.vue'
import ParametrosSistema from '@/views/parametros/ParametrosSistema.vue'
import AtualizarUpfPr from '@/views/parametros/AtualizarUpfPr.vue'
import ExcecoesSistema from '@/views/excecoes/ExcecoesSistema.vue'
import AgendaSistema from '@/views/agenda/AgendaSistema.vue'
import AgendaPrazos from '@/views/agenda/AgendaPrazos.vue'
import ConsultarCDA from '@/views/consultar-cdas/ConsultarCDA.vue'
import ConsultarCDAExibir from '@/views/consultar-cdas/ConsultarCDAExibir.vue'
import RelatorioProtestoAjuizamento from '@/views/relatorios/protestoAjuizamento/RelatorioProtestoAjuizamento.vue'
import AcompanhamentoProtesto from '@/views/acompanhamento-protesto/Dashboard.vue'
import ConsultaAcompanhamentoProtesto from '@/views/acompanhamento-protesto/consulta/ConsultaDashboard.vue'
import ImportarProcessosDigitalizados from '@/views/importar/processos-digitalizados/ImportarProcessosDigitalizados.vue'
import CadastroLimiteProtesto from '@/views/cruds/limiteProtesto/CadastroLimiteProtesto.vue'
import Migracao from '@/views/migracao/Migracao.vue'
import ProcessoMigradoEditar from '@/views/migracao/ProcessoMigradoEditar.vue'
import ProcessamentoArquivos from '@/views/processamento-arquivo/ProcessamentoArquivosPagamento.vue'
import TipoCreditoAssunto from '@/views/cruds/tipoCreditoAssunto/ManterTipoCreditoAssunto.vue'
import TipoCreditoAssuntoEditar from '@/views/cruds/tipoCreditoAssunto/ManterTipoCreditoAssuntoEditar.vue'
import TipoCreditoAssuntoExibir from '@/views/cruds/tipoCreditoAssunto/ManterTipoCreditoAssuntoExibir.vue'
import ParametrosGr from '@/views/parametrosGr/ParametrosGr.vue'

import ManterMinuta from '@/views/cruds/minuta/ManterMinuta.vue'
import ManterMinutaEditar from '@/views/cruds/minuta/ManterMinutaEditar.vue'
import ManterMinutaAlterar from '@/views/cruds/minuta/ManterMinutaAlterar.vue'
import ManterMinutaExibir from '@/views/cruds/minuta/ManterMinutaExibir.vue'

import ManterFeriado from '@/views/cruds/feriado/ManterFeriado.vue'
import ManterPalavraChave from '@/views/cruds/palavra-chave/ManterPalavraChave.vue'
import ManterGrupoTrabalho from '@/views/cruds/grupo-trabalho/ManterGrupoTrabalho.vue'

import Home from '@/views/home/Home.vue'

//error pages
import AccessDenied from '@/views/layout/errors/Deny'
import NotFound from '@/views/layout/errors/NotFound'
import ConsultarInfoconv from "@/views/consulta-infoconv/ConsultarInfoconv.vue";
import ConsultarEpaf from "@/views/consulta-epaf/ConsultarEpaf.vue";
// import Info from '@/views/info/InformacoesLegais'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	linkActiveClass: 'open active',
	scrollBehavior: () => ({
		y: 0
	}),
	routes: [{
		path: '/',
		name: '',
		component: Home,
		meta: {
			breadcrumb: true,
			label: 'Home /',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA', 'PGEPROAJU-RECEITAFEDERAL', 'PGEPROAJU-EPAF', 'PGEPROAJU-CONSULTA', 'PGEPROAJU-RELATORIO', 'PGEPROAJU-CONSULTAEDITAEF', 'PGEPROAJU-AGENDAPRAZO-PROC', 'PGEPROAJU-AGENDAPRAZO-ASSES']
		}
	},
	{
		path: '/home',
		name: 'home',
		component: Home,
		meta: {
			breadcrumb: true,
			label: 'Home /',
			requiresAuth: false,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA', 'PGEPROAJU-RECEITAFEDERAL', 'PGEPROAJU-EPAF', 'PGEPROAJU-CONSULTA', 'PGEPROAJU-RELATORIO', 'PGEPROAJU-CONSULTAEDITAEF', 'PGEPROAJU-AGENDAPRAZO-PROC', 'PGEPROAJU-AGENDAPRAZO-ASSES']
		}
	},
	{
		path: '/info',
		name: 'info',
		component: () => import('@/views/info/InformacoesLegais'),
		meta: {
			requiresAuth: false

		}
	},
	{
		path: '/serie',
		name: 'serie',
		component: Serie,
		meta: {
			breadcrumb: true,
			label: 'Coordenação / Incluir Serie',
			requiresAuth: false,

			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/dashboard',
		name: 'dashboard',
		component: Dashboard,
		meta: {
			breadcrumb: true,
			label: 'Home / Dashboard',
			requiresAuth: true,

			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/assinar-cartas-lote',
		name: 'AssinarCartasEmLote',
		component: ConsultarCartasParaAssinatura,
		meta: {
			breadcrumb: true,
			label: 'Home / Cartas Para Assinar e Emissão em Lote',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/emitir-cartas',
		name: 'EmitirCartas',
		component: EmitirCartasPesquisar,
		meta: {
			breadcrumb: true,
			label: 'Home / Cartas Emitidas e Emissão Individual',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/emitir-cartas-incluir',
		name: 'EmitirCartasIncluir',
		component: EmitirCartasIncluir,
		meta: {
			breadcrumb: true,
			label: 'Home / Cartas Emitidas e Emissão Individual / Incluir',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/exemplo',
		name: 'exemplo',
		component: () => import('@/views/exemplo/Formulario.vue'),
		meta: {
			breadcrumb: true,
			label: 'Home / Exemplo',
			requiresAuth: false,

			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/ajuizamento/exibir-divida-disponivel',
		name: 'ExibirDividaDisponivel',
		component: ExibirDividaDisponivel,
		meta: {
			breadcrumb: true,
			label: 'Home / Ajuizamento / Exibir Dívidas Disponíveis',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/ajuizamento/exibir-erros-ajuizamento',
		name: 'ExibirErrosAjuizamento',
		component: ExibirErrosAjuizamento,
		meta: {
			breadcrumb: true,
			label: 'Home / Ajuizamento / Exibir Erros Ajuizamento',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/ajuizamento/exibir-excluidas-ajuizamento',
		name: 'ExibirExcluidasAjuizamento',
		component: ExibirExcluidasAjuizamento,
		meta: {
			breadcrumb: true,
			label: 'Home / Ajuizamento / Exibir CDAs Excluídas',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/protesto/exibir-erros-protesto',
		name: 'ExibirErrosProtesto',
		component: ExibirErrosProtesto,
		meta: {
			breadcrumb: true,
			label: 'Home / Protesto / Exibir Erros Protesto',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/protesto/exibir-excluidas-protesto',
		name: 'ExibirExcluidasProtesto',
		component: ExibirExcluidasProtesto,
		meta: {
			breadcrumb: true,
			label: 'Home / Protesto / Exibir CDAs Excluídas',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/ajuizamento/exibir-excecoes-ajuizamento',
		name: 'ExibirExcecoesAjuizamento',
		component: ExibirExcecoesAjuizamento,
		meta: {
			breadcrumb: true,
			label: 'Home / Ajuizamento / Exibir Exceções Ajuizamento',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/protesto/exibir-excecoes-protesto',
		name: 'ExibirExcecoesProtesto',
		component: ExibirExcecoesProtesto,
		meta: {
			breadcrumb: true,
			label: 'Home / Protesto / Exibir Exceções Protesto',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/protesto/exibir-dividas-enviadas-protesto',
		name: 'ExibirCDAEnviadasCRA',
		component: ExibirCDAEnviadasCRA,
		meta: {
			breadcrumb: true,
			label: 'Home / Protesto / Exibir Dívidas Enviadas para Protesto',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/ajuizamento/exibir-ajuizadas',
		name: 'ExibirAjuizadas',
		component: ExibirAjuizadas,
		meta: {
			breadcrumb: true,
			label: 'Home / Ajuizamento / Exibir Dívidas Ajuizadas',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		},
	},
	{
		path: '/protesto/cda-disponivel-protesto',
		name: 'CDADisponivelProtesto',
		component: CDADisponivelProtesto,
		meta: {
			breadcrumb: true,
			label: 'Home / Protesto / CDA Disponível para Protesto',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/protesto/cda-selecionadas-protesto',
		name: 'CDASelecionadasProtesto',
		component: CDASelecionadasProtesto,
		meta: {
			breadcrumb: true,
			label: 'Home / Protesto / CDA Selecionada para Protesto',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/ajuizamento/exibir-processos-montados',
		name: 'ExibirProcessosMontados',
		component: ExibirProcessosMontados,
		meta: {
			breadcrumb: true,
			label: 'Home / Ajuizamento / Exibir Processos Montados',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/tabelionato',
		name: 'ManterTabelionato',
		component: ManterTabelionato,
		meta: {
			breadcrumb: true,
			label: 'Home / Cadastro de Tabelionato',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/comarca',
		name: 'ManterComarca',
		component: ManterComarca,
		meta: {
			breadcrumb: true,
			label: 'Home / Cadastro de Comarca',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/comarca/editar',
		name: 'ManterComarcaEditar',
		component: ManterComarcaEditar,
		meta: {
			breadcrumb: true,
			label: 'Home / Editar Comarca',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/comarca/exibir',
		name: 'ManterComarcaExibir',
		component: ManterComarcaExibir,
		meta: {
			breadcrumb: true,
			label: 'Home / Exibir Comarca',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/minuta',
		name: 'ManterMinuta',
		component: ManterMinuta,
		meta: {
			breadcrumb: true,
			label: 'Home / Cadastro de Modelo',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/minuta/editar',
		name: 'ManterMinutaEditar',
		component: ManterMinutaEditar,
		meta: {
			breadcrumb: true,
			label: 'Home / Cadastro de Modelo',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/minuta/alterar',
		name: 'ManterMinutaEditar',
		component: ManterMinutaAlterar,
		meta: {
			breadcrumb: true,
			label: 'Home / Cadastro de Modelo',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/minuta/exibir',
		name: 'ManterMinutaExibir',
		component: ManterMinutaExibir,
		meta: {
			breadcrumb: true,
			label: 'Home / Cadastro de Modelo',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/crud/feriado',
		name: 'ManterFeriado',
		component: ManterFeriado,
		meta: {
			breadcrumb: true,
			label: 'Home / Cadastro de Feriado',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/crud/palavra-chave',
		name: 'ManterPalavraChave',
		component: ManterPalavraChave,
		meta: {
			breadcrumb: true,
			label: 'Home / Cadastro de Palavra-chave',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/crud/grupo-trabalho',
		name: 'ManterGrupoTrabalho',
		component: ManterGrupoTrabalho,
		meta: {
			breadcrumb: true,
			label: 'Home / Cadastro de Grupo de Trabalho',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/reu-federal',
		name: 'ManterReuFederal',
		component: ManterReuFederal,
		meta: {
			breadcrumb: true,
			label: 'Home / Cadastro de Réu Federal',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/usuario',
		name: 'ManterUsuario',
		component: ManterUsuario,
		meta: {
			breadcrumb: true,
			label: 'Home / Cadastro de Usuário',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/procurador',
		name: 'ManterProcurador',
		component: ManterProcurador,
		meta: {
			breadcrumb: true,
			label: 'Home / Cadastro de Procurador',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/procurador/editar',
		name: 'ManterProcuradorEditar',
		component: ManterProcuradorEditar,
		meta: {
			breadcrumb: true,
			label: 'Home / Editar Procurador',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/procurador/exibir',
		name: 'ManterProcuradorExibir',
		component: ManterProcuradorExibir,
		meta: {
			breadcrumb: true,
			label: 'Home / Exibir Procurador',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/juizo',
		name: 'ManterJuizo',
		component: ManterJuizo,
		meta: {
			breadcrumb: true,
			label: 'Home / Cadastro de Juízo',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/peticao',
		name: 'ManterPeticao',
		component: ManterPeticao,
		meta: {
			breadcrumb: true,
			label: 'Home / Cadastro de Petição',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/peticao/editar',
		name: 'ManterPeticaoEditar',
		component: ManterPeticaoEditar,
		meta: {
			breadcrumb: true,
			label: 'Home / Editar Petição',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/peticao/exibir',
		name: 'ManterPeticaoExibir',
		component: ManterPeticaoExibir,
		meta: {
			breadcrumb: true,
			label: 'Home / Exibir Petição',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/parametros-sistema',
		name: 'ParametrosSistema',
		component: ParametrosSistema,
		meta: {
			breadcrumb: true,
			label: 'Home / Cadastro de Parâmetros',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/parametros-gr',
		name: 'ParametrosGr',
		component: ParametrosGr,
		meta: {
			breadcrumb: true,
			label: 'Home / Parâmetros GR',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/atualizar-upf-pr',
		name: 'atualizarUpfPr',
		component: AtualizarUpfPr,
		meta: {
			breadcrumb: true,
			label: 'Home / Atualizar UPF/PR',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/excecoes',
		name: 'ExcecoesSistema',
		component: ExcecoesSistema,
		meta: {
			breadcrumb: true,
			label: 'Home / Exceções',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/consultar-cdas',
		name: "Pesquisa",
		component: ConsultarCDA,
		meta: {
			breadcrumb: true,
			label: "Home / Pesquisa",
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA', 'PGEPROAJU-CONSULTA', 'PGEPROAJU-CONSULTAEDITAEF', 'PGEPROAJU-AGENDAPRAZO-PROC', 'PGEPROAJU-AGENDAPRAZO-ASSES']
		}
	},
	{
		path: '/consultar-cdas/exibir/:id',
		name: "Exibir Histórico de CDA",
		component: ConsultarCDAExibir,
		meta: {
			breadcrumb: true,
			label: "Home / Exibir Histórico de CDA",
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA', 'PGEPROAJU-CONSULTA', 'PGEPROAJU-CONSULTAEDITAEF', 'PGEPROAJU-AGENDAPRAZO-PROC', 'PGEPROAJU-AGENDAPRAZO-ASSES']
		}
	},
	{
		path: '/relatorio-protesto-ajuizamento',
		name: 'RelatorioProtestoAjuizamento',
		component: RelatorioProtestoAjuizamento,
		meta: {
			breadcrumb: true,
			label: 'Home / Relatório Protesto-Ajuizamento',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA', 'PGEPROAJU-RELATORIO']
		}
	},
	{
		path: '/acompanhamento-protesto',
		name: 'AcompanhamentoProtesto',
		component: AcompanhamentoProtesto,
		meta: {
			breadcrumb: true,
			label: 'Home / Acompanhamento do Protesto',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/acompanhamento-protesto/consultar',
		name: 'ConsultaAcompanhamentoProtesto',
		component: ConsultaAcompanhamentoProtesto,
		meta: {
			breadcrumb: true,
			label: 'Home / Acompanhamento do Protesto / Consultar',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
		}
	},
	{
		path: '/limiteProtestos',
		name: 'CadastroLimiteProtesto',
		component: CadastroLimiteProtesto,
		meta: {
			breadcrumb: true,
			label: 'Home / Cadastro de Limite Protestos',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/importar-processos-digitalizados',
		name: 'ImportarProcessosDigitalizados',
		component: ImportarProcessosDigitalizados,
		meta: {
			breadcrumb: true,
			label: 'Home / Importar Processos Digitalizados',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/migracao',
		name: 'Migracao',
		component: Migracao,
		meta: {
			breadcrumb: true,
			label: 'Home / Migração e Edição de EF',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-CONSULTAEDITAEF']
		}
	},
	{
		path: '/agenda',
		name: 'AgendaSistema',
		component: AgendaSistema,
		meta: {
			breadcrumb: false,
			label: 'Home / Agenda de Prazos',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-AGENDAPRAZO-PROC', 'PGEPROAJU-AGENDAPRAZO-ASSES']
		}
	},
	{
		path: '/agendaPrazos',
		name: 'AgendaPrazos',
		component: AgendaPrazos,
		meta: {
			breadcrumb: false,
			label: 'Home / Agenda de Prazos',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-AGENDAPRAZO-PROC', 'PGEPROAJU-AGENDAPRAZO-ASSES']
		}
	},
	{
		path: '/migracao/processo/editar',
		name: 'Migracao',
		component: ProcessoMigradoEditar,
		meta: {
			breadcrumb: true,
			label: 'Home / Migração e Edição de EF',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-CONSULTAEDITAEF']
		}
	},
	{
		path: '/processamento-arquivos',
		name: 'ProcessamentoArquivos',
		component: ProcessamentoArquivos,
		meta: {
			breadcrumb: true,
			label: 'Home / Processamento de Arquivos',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/tipo-credito-assunto',
		name: 'TipoCreditoAssunto',
		component: TipoCreditoAssunto,
		meta: {
			breadcrumb: true,
			label: 'Home / Tipo de Crédito/Assunto',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/tipo-credito-assunto/editar',
		name: 'TipoCreditoAssuntoEditar',
		component: TipoCreditoAssuntoEditar,
		meta: {
			breadcrumb: true,
			label: 'Home / Editar Tipo de Crédito/Assunto',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/tipo-credito-assunto/exibir',
		name: 'TipoCreditoAssuntoExibir',
		component: TipoCreditoAssuntoExibir,
		meta: {
			breadcrumb: true,
			label: 'Home / Exibir Tipo de Crédito/Assunto',
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR']
		}
	},
	{
		path: '/consulta-receita-federal',
		name: "Receita Federal",
		component: ConsultarInfoconv,
		meta: {
			breadcrumb: true,
			label: "Home / Consultas / Receita Federal",
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-RECEITAFEDERAL']
		}
	},
	{
		path: '/consulta-epaf',
		name: "ePAF",
		component: ConsultarEpaf,
		meta: {
			breadcrumb: true,
			label: "Home / Consultas / ePAF",
			requiresAuth: true,
			groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-EPAF']
		}
	},
	//error pages
	{
		path: '/accessdenied',
		name: 'AccessDenied',
		component: AccessDenied,
		meta: {
			requiresAuth: false
		}
	},
	{
		path: '/*',
		name: 'NotFound',
		components: {
			secundario: NotFound,
			default: NotFound,
		},
		meta: {
			requiresAuth: false
		}
	}
	]
})

// router.beforeEach((to, from, next) => {
//   store.commit("setMessages",null);
//   store.commit('setLayout', 'admin');
//   //protected access

//   //Monitoring, Notfound, AccessDenied
//   if(to.name == "NotFound" || to.name == "AccessDenied") {
//     store.commit('setLayout', 'blank');
//     next()
//     return
//   }

//   //public access
//   next()
//   return
// });

router.beforeEach((to, from, next) => {
	store.dispatch('limparMensagens')

	//protected access
	if (to.meta.requiresAuth) {
		(async () => {
			if (await store.dispatch('authFilter')) {
				if (store.getters.isAuthenticated == true) {
					let userJson = store.getters.getUser;

					//root redirect
					if (to.path === "/" || to.path === "/home") {
						store.commit('setLayout', 'admin');
						let userData = JSON.parse(userJson);

						if (userData.groups) {
							let permission = false,
								relatorio = false,
								groupName = '';
							let groupsDashboard = ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA'];
							let groupsRelatorio = ['PGEPROAJU-RELATORIO'];
							let groupsEPAF = ['PGEPROAJU-EPAF'];
							let receitaFederal = ['PGEPROAJU-RECEITAFEDERAL'];

							for (let i = 0; i < userData.groups.length; i++) {
								groupName = userData.groups[i];

								if (groupsDashboard.indexOf(groupName) != -1) {
									permission = true;
									break;

								} else if (groupsRelatorio.indexOf(groupName) != -1) {
									relatorio = true;
									break;
								} else if (groupsEPAF.indexOf(groupName) != -1) {
									epaf = true;
									break;
								} else if (receitaFederal.indexOf(groupName) != -1) {
									receitaFederal = true;
									break;
								}
							}

							if (permission) {
								next("/dashboard")

							} else if (relatorio) {
								next("/relatorio-protesto-ajuizamento")

							} else if (epaf) {
								next("/consulta-epaf")

							} else if (receitaFederal) {
								next("/consulta-receita-federal")

							} else {
								next("/home")
							}
						}
					}

					//permission groups
					if (to.meta.groups && to.meta.groups.length > 0) {
						let userData = JSON.parse(userJson);

						if (userData.groups) {
							let permission = false,
								groupName = '';

							for (let i = 0; i < userData.groups.length; i++) {
								groupName = userData.groups[i];

								if (to.meta.groups.indexOf(groupName) != -1) {
									permission = true;
									break;
								}
							}

							if (permission) { //permission granted
								store.commit('setLayout', 'admin');
								next();

								return;

							} else { //permission denied
								console.log("usuário não possui o grupo necessário para acessar a função: " + userData.groups)
								store.commit("limparUserState");
								store.commit('setLayout', 'blank');
								next("/accessdenied");

								return;
							}

						} else { //permission denied
							console.log("usuário não possui o grupo necessário para acessar a função: " + userData.groups)
							store.commit("limparUserState");
							store.commit('setLayout', 'blank');
							next("/accessdenied");

							return;
						}
					}

				} else {
					console.log("usuário não está autenticado.")
					store.commit("limparUserState");
					store.commit('setLayout', 'blank');
					next("/accessdenied");
					return;
				}
			}
		})();
	}

	//Monitoring, Notfound, AccessDenied
	if (to.name == "NotFound" || to.name == "AccessDenied") {
		store.commit('setLayout', 'blank');
		next()
		return
	}

	//public access
	next()
	return
});

export default router;
